/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.title-bar[_ngcontent-%COMP%]{background-color:#0080ff}div.container[_ngcontent-%COMP%]{color:#fff;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;font-size:26px;align-content:center;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between;padding-top:4px;padding-bottom:4px}h1[_ngcontent-%COMP%]{font-size:1.5rem;margin-bottom:.5rem;margin-top:.5rem;text-transform:lowercase}h1[_ngcontent-%COMP%]:first-letter{text-transform:uppercase}"];
export { styles as styles };
//# sourceMappingURL=title-bar.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/title-bar/title-bar.component.scss.shim.ngstyle.js
// module id = 1716
// module chunks = 27 28 29